import { useTranslation } from 'react-i18next';
import { Button } from '@teo/components';
import React from 'react';
function UploadMainImageContainer({
  photoInfo,
  fileInputRef,
  handleUploadPhoto,
  uploadLogo,
  courseImg,
  courseEdit,
  setIsOpenLibraryModal,
  learningPathImg,
  learningPathHomeImg,
}: any) {
  const { t } = useTranslation();
  if (!photoInfo && !uploadLogo) {
    return null;
  }
  return (
    <div
      className={`flex flex-col ${
        learningPathHomeImg || courseEdit ? 'p-0' : 'p-3'
      }`}
    >
      <div className="flex items-center">
        <img
          alt="logo"
          src={uploadLogo ? uploadLogo : URL.createObjectURL(photoInfo)}
          className={`mr-3 h-16 flex-[1_0_64px] rounded object-cover object-center ${
            courseImg &&
            'h-[360px] w-full flex-[1_0_100%] sm:w-64 sm:flex-[1_0_64px]'
          } ${learningPathImg && '!mr-0 !h-[288px]'} ${
            learningPathHomeImg && '!mr-0 !h-[150px]'
          } ${courseEdit && '!mr-0'}`}
        />
      </div>
      <div
        className={`flex pt-6 ${
          learningPathHomeImg ? 'flex-col gap-3' : 'justify-end'
        }`}
      >
        <Button
          variant="outline"
          className={`${!learningPathHomeImg && 'mr-2'}`}
          onClick={() => setIsOpenLibraryModal(true)}
        >
          {courseImg
            ? t('pages.upload_dropzone_section.upload_button_img_2')
            : t('pages.upload_dropzone_section.upload_button_2')}
        </Button>
        {/* <Button
          variant="outline"
          size="md"
          onClick={() => {
            fileInputRef.current?.click();
          }}
          className="text-base font-semibold"
        >
          {courseImg
            ? t('pages.upload_dropzone_section.upload_button_img_2')
            : t('pages.upload_dropzone_section.upload_button_2')}
        </Button> */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleUploadPhoto}
          accept="image/*"
          style={{ display: 'none' }}
          multiple={false}
        />
      </div>
    </div>
  );
}
export default UploadMainImageContainer;
